import { ModalContext } from 'app/app';
import axios from 'axios';
import { Pagination } from 'components/Pagination';
import {
  Animate,
  Grid,
  Search,
  Table,
  ViewContext,
} from 'components/lib';
import DateUtils from 'helpers/dateUtils';
import { useContext, useEffect, useState } from 'react';
import styles from './styles.module.scss';

export function Compliance(props) {
  const { setModal } = useContext(ModalContext);

  const [payload, setPayload] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQueryString, setSearchQueryString] = useState('');

  const context = useContext(ViewContext);

  async function listDocuments(page, search) {
    setLoading(true);

    await axios
      .get(
        `/api/document?page=${page}&search=${search}&status=pending_review`
      )
      .then(async (res) => {
        setLoading(false);
        setPayload(res.data.data);

        const helper = new DateUtils();
        const timezone = await helper.getTimezone();

        const formattedValues = res.data.data.data.map((document) => {
          return {
            id: document.id,
            name: document.name,
            uploaded_by: document.uploaded_by,
            type:
              document.type === 'w9'
                ? 'W-9'
                : document.type === 'agency_contract'
                  ? 'Agency Contract'
                  : document.type === 'compensation_agreement'
                    ? 'Compensation Agreement'
                    : document.type === 'license'
                      ? 'License'
                      : document.type === 'eo'
                        ? 'E&O'
                        : 'Other',
            status: document.status.replaceAll('_', ' '),
            expiration_date: document.expiration_date
              ? helper.formatIsoToCommomDate(document.expiration_date)
              : '',
            state: document.state,
            link: document.s3_link,
            'Created At': helper.timestamp(
              document.createdAt,
              timezone
            ),
          };
        });

        setData(formattedValues);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);

        context.notification.show(
          'Failed to load table data',
          'error',
          true,
          'toast',
          'x-circle'
        );
      });
  }

  useEffect(() => {
    listDocuments(page, searchQueryString);
  }, [page, searchQueryString]);

  return (
    <Animate type="pop">
      <Grid cols="1">
        <div className={styles.wrapper} style={{ marginTop: 0 }}>
          <div style={{ marginBottom: 10 }}>
            <Search
              callback={(query) => {
                setSearchQueryString(query);
              }}
            />
          </div>
          {window.location.host === 'localhost:5002' ? (
            <iframe
              id="receiver"
              src={`http://localhost:3000`}
              width="500"
              height="200"
              style={{ display: 'none' }}
            />
          ) : (
            <iframe
              id="receiver"
              src={`https://app.coverbadger.com`}
              width="500"
              height="200"
              style={{ display: 'none' }}
            />
          )}
          <Table
            loading={loading}
            data={data}
            badge={{
              col: 'status',
              condition: [
                { value: 'Active', color: 'green' },
                { value: 'Pending Review', color: 'purple' },
                { value: 'Expired', color: 'orange' },
                { value: 'Denied', color: 'red' },
              ],
            }}
            show={[
              'name',
              'type',
              'uploaded_by',
              'Created At',
              'status',
              'expiration_date',
              'state',
            ]}
            actions={{
              custom: [
                {
                  icon: 'download',
                  action: (row) => {
                    window.open(row.link);
                  },
                  color: '#637381',
                  tooltip: 'Download document',
                },
                {
                  icon: 'edit',
                  action: (row) => {
                    setModal({
                      name: 'edit_document_modal',
                      data: {
                        id: row.id,
                        status: row.status
                          .replaceAll(' ', '_')
                          .toLowerCase(),
                      },
                      action: async () => {
                        listDocuments(page, searchQueryString);
                      },
                    });
                  },
                  color: '#637381',
                  tooltip: 'Edit document',
                },
                {
                  icon: 'trash',
                  action: (doc) => {
                    setModal({
                      name: 'confirmation',
                      data: {
                        title: `Delete document`,
                        description: `Do you really want to delete this document"?`,
                      },
                      action: async () => {
                        setModal('');
                        setLoading(true);

                        await axios
                          .delete(`/api/document/${doc.id}`)
                          .then(() => {
                            listDocuments(page, searchQueryString, false);
                          })
                          .catch(() => {
                            setLoading(false);

                            context.notification.show(
                              'Failed to load table data',
                              'error',
                              true,
                              'toast',
                              'x-circle'
                            );
                          });
                      },
                    });
                  },
                  color: '#637381',
                  tooltip: 'Delete document',
                },
              ],
            }}
          />
          {payload && !loading && (
            <Pagination
              pagesCount={payload.pages_count}
              active={payload.page}
              onChange={async (newPage) => {
                setPage(newPage);
                listDocuments(newPage, searchQueryString);
              }}
            />
          )}
        </div>
      </Grid>
    </Animate>
  );
}
